/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { Box, Container, Grid, Button } from '@mui/material';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useCalculateDealValue from 'views/rebranded-module/common/hooks/useCalculateDealValue';
import {
  DealTitleSection,
  DealInformationsSection,
  DealCardsSectionSkeleton,
  DealCardsSection,
  DealWigdetSection,
} from 'views/rebranded-module/deals-module/DealDetailsViewV2/components';
import StyledBox from 'views/rebranded-module/deals-module/DealDetailsViewV2/DealDetailsViewV2.styles';
import useRenderAiBot from 'views/common/hooks/useRenderAiBot';
import { PAGES_GA_IDENTIFIERS } from 'views/common/utils/constants';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import {
  ImgBox,
  ParticipatingLocationsSkeleton,
  ParticipatingLocationsWrapper,
} from 'views/rebranded-module/common/components';
import { LazyLoad } from 'views/common/components';
import ScrollTo from 'lib/utils/ScrollTo';
import useLayoutHeights from 'views/rebranded-module/common/hooks/UseLayoutHeight';

const DealDetailsViewV2: React.FC<any> = (props) => {
  const cmsData = useContent();
  const { serverData: dealData, rentalWidgetInit } = props;
  const getSizedImage = useAdabtiveMultiSizeImage();
  const dealValue = useCalculateDealValue();
  useRenderAiBot(false);
  const [showActionBar, setShowActionBar] = useState(true);
  const { LAYOUT_HEIGHT, LAYOUT_HEIGHT_SM } = useLayoutHeights();
  const handleShowActionBar = (value) => {
    setShowActionBar(value);
  };

  const handleScrollToWiget = (id) => ScrollTo(id, -LAYOUT_HEIGHT_SM * 8);
  useEffect(() => {
    window.gtag('event', 'landing_page_view', {
      page_identifier: PAGES_GA_IDENTIFIERS.DEAL,
    });
  }, []);
  return (
    <>
      <Head>
        {dealData?.seo_values && generateMetaData(dealData.seo_values)}
      </Head>
      <StyledBox
        layoutHeight={LAYOUT_HEIGHT}
        smallLayoutHeight={LAYOUT_HEIGHT_SM}>
        <Box className="DVHeroContainer">
          <Box className="DVBGContainer">
            <ImgBox
              image={{
                src: getSizedImage(
                  cmsData.DealDetailsPage.heroBackground.sizes,
                ),
                alt: cmsData.DealDetailsPage.heroBackground.alt,
              }}
              width="100%"
              height="100%"
            />
          </Box>
          <Box className="DVContentContainer">
            <Container maxWidth="xl">
              <DealTitleSection dealTitle={dealData?.deal.title} />
              <Grid container columnSpacing={10} justifyContent="space-between">
                <Grid item xl={7.75} lg={7} md={12} xs={12}>
                  <DealInformationsSection
                    deal={dealData?.deal}
                    vehicleModel={dealData?.deal_vehicle_model_names || ''}
                  />
                </Grid>
                {/* widget side  */}
                <Grid item xl={4.25} lg={5} md={12} xs={12}>
                  <Box className="DDVWigdetContainre">
                    <DealWigdetSection
                      deal={dealData?.deal}
                      rentalWidgetInit={rentalWidgetInit}
                      dealTours={dealData?.deal_tours}
                      handleShowActionBar={handleShowActionBar}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Box>
        <Container maxWidth="xl">
          {/* Map Group Section */}
          {dealData?.geography_component?.locations_count > 0 && (
            <Box className="DVMapSectionContainer">
              <LazyLoad
                skeleton={<ParticipatingLocationsSkeleton />}
                dataLoaded={dealData}>
                <ParticipatingLocationsWrapper
                  mapGroupData={dealData?.geography_component}
                  placeholder={
                    cmsData.DealDetailsPage.locationSearchInputPlaceholder
                  }
                  content={cmsData.ParticipatingLocationsComponent}
                  target="_blank"
                />
              </LazyLoad>
            </Box>
          )}
        </Container>
        <Container maxWidth="xxl">
          <LazyLoad
            skeleton={<DealCardsSectionSkeleton />}
            dataLoaded={dealData}>
            <DealCardsSection dealData={dealData} dealValue={dealValue} />
          </LazyLoad>
        </Container>

        {showActionBar && (
          <Box className="DVBookBtnContainer">
            <Button
              fullWidth
              variant="contained"
              className="DVBookBtn"
              onClick={() => handleScrollToWiget('deal-offer')}>
              {cmsData.DealDetailsPage.bookNowButtonLabel}
            </Button>
          </Box>
        )}
      </StyledBox>
    </>
  );
};
export { DealDetailsViewV2 };
